<section class="mainSection login-page">
    <div class="container align-content-center">
        <div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6 m-auto">
            <div class="card shadow p-2 p-md-3">
                <div class="logo">
                    <img src="/assets/images/home/logo_medium.png" class="img-fluid">
                </div>
                <div class="login-button m-auto mt-5 col-8 col-sm-5 col-md-6 d-grid">
                    <button class="btn btn-primary" (click)="login()" >
                        <img src="/assets/images/home/user-lock.svg" class="user-img">
                        <span>Entrar</span>
                    </button>
                </div>
                <div class="footer mt-5 d-flex flex-column align-items-center text-center">
                    <span> Indicadores {{currentYear}}</span>
                    <span>Secretaria de Economia e Planejamento do Espírito Santo</span>
                </div>
            </div>
        </div>
    </div>
</section>